import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Stories from "@/pages/Stories";
import Partner from "@/pages/Partner";
import VolunteerPage from "@/pages/VolunteerPage";
import Membership from "@/pages/Membership";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Auth callback FIRST (sync, before any other routing)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/donate" element={<Donate />} />
      <Route path="/donate/success" element={<DonateSuccess />} />
      <Route path="/stories" element={<Stories />} />
      <Route path="/volunteer" element={<VolunteerPage />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/collaborate" element={<Partner />} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/join" element={<Membership />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
